import { AddressForm } from '@shopify/theme-addresses';

export default class CustomerAddresses {
  constructor() {
    this.initAddressForms();
  }

  initAddressForms() {
    [...document.querySelectorAll('[data-address="root"]')].forEach(formEl => {
      AddressForm(formEl, document.documentElement.lang);
    });

    [...document.querySelectorAll('.js-reset-trigger')].forEach(trigger => {
      const { formId } = trigger.dataset;
      trigger.addEventListener('click', e => {
        e.preventDefault();
        document.getElementById(formId).reset();
      });
    });

    [...document.querySelectorAll('.js-address-delete-form')].forEach(deleteForm => {
      deleteForm.addEventListener('submit', event => {
        const confirmMessage = event.target.getAttribute('data-confirm-message');

        // eslint-disable-next-line
        if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          event.preventDefault();
        }
      });
    });
  }
}
